import { ArrowRight, Lock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { advanceAttempt } from "@/lib/api";
import { toast } from "sonner";
import { useState } from "react";

export default function Interstitial({ attempt, onAdvance }) {
  const [busy, setBusy] = useState(false);
  const completedIdx = attempt.current_index;
  const totalConcepts = attempt.sequence_ids.length;

  const advance = async () => {
    setBusy(true);
    try {
      await advanceAttempt(attempt.id);
      await onAdvance();
    } catch (e) {
      toast.error(e?.response?.data?.detail || e.message);
    } finally { setBusy(false); }
  };

  return (
    <div className="max-w-3xl mx-auto px-6 md:px-12 py-20 text-center" data-testid="interstitial">
      <Lock className="mx-auto" size={28} />
      <div className="label-mono mt-6">Concept {completedIdx + 1} of {totalConcepts} complete</div>
      <h2 className="font-display text-3xl md:text-4xl font-bold tracking-tight mt-3">
        Result not revealed yet
      </h2>
      <p className="text-sm text-[var(--iddl-muted)] mt-4 max-w-xl mx-auto">
        IDDL withholds per-concept verdicts. The overall outcome is computed
        and disclosed only after all three concepts are completed. Continue to
        the next concept when you are ready.
      </p>
      <div className="mt-10">
        <Button onClick={advance} disabled={busy} data-testid="btn-advance" className="btn-ink rounded-none h-12 px-7">
          {busy ? "Advancing…" : "Continue to next concept"} <ArrowRight size={14} className="ml-2" />
        </Button>
      </div>
    </div>
  );
}
